// CANONICAL COPY (GH #7115). src/constants/obligations/obl-records-of-processing.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-records-of-processing',
  title: 'Maintain records of processing activities (RoPA)',
  description:
    "Confirm that records of all processing activities under the organisation's responsibility as controller are maintained in writing, including electronic form, as required by GDPR Article 30. Records shall describe the controller and DPO contact details, purposes of processing, categories of data subjects and personal data, categories of recipients, transfers to third countries with documentation of safeguards, envisaged retention periods and a general description of the technical and organisational security measures. Records shall be made available to the supervisory authority on request.",
  category: 'compliance',
  scfIds: ['SCF-PRV-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'ropa-entries-exist',
      description:
        'At least one active processing activity is recorded in the in-app RoPA register',
    },
    {
      type: 'document-published',
      description: 'Records of processing activities (RoPA) document is published',
    },
    { type: 'document-approved', description: 'RoPA document has been approved' },
    { type: 'document-within-sla', description: 'RoPA document review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
